import {
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import placeholder from "assets/imgs/placeholder-img.jpg";
import placeholderVideo from "assets/imgs/placeholder-video.jpg";
import icon from "assets/imgs/icon.png";

import { isImage, newId, getExtension, isMp4 } from "utils/Utils.js";
import Firebase from "Firebase.js";
import { Autocomplete } from "@material-ui/lab";

export default function CriarProduto() {
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [fichaTecnica, setFichaTecnica] = useState("");
  const [valor, setValor] = useState("");
  const [anunciante, setAnunciante] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [tags, setTags] = useState("");
  const [checkoutUrl, setCheckoutUrl] = useState("");

  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (
      nome &&
      image &&
      video &&
      descricao &&
      fichaTecnica &&
      valor &&
      anunciante &&
      categorias.length > 0 &&
      tags.length > 0 &&
      checkoutUrl
    ) {
      if (isImage(image.name) && isMp4(video.name)) {
        setLoading(true);
        const id = newId();
        const filename = id + "." + getExtension(image.name);
        const filenameVideo = id + "." + getExtension(video.name);

        let resStorageImage = await Firebase.fire
          .storage()
          .ref("produtos/" + id + "/" + filename)
          .put(image);
        const imageUrl = await resStorageImage.ref.getDownloadURL();

        let resStorageVideo = await Firebase.fire
          .storage()
          .ref("produtos/" + id + "/" + filenameVideo)
          .put(video);
        const videoUrl = await resStorageVideo.ref.getDownloadURL();

        await Firebase.fire.firestore().collection("produtos").doc(id).set({
          id: id,
          nome: nome,
          descricao: descricao,
          imageFile: filename,
          imageUrl: imageUrl,
          videoFile: filenameVideo,
          videoUrl: videoUrl,
          fichaTecnica: fichaTecnica,
          valor: valor,
          anunciante: anunciante,
          categorias: categorias,
          tags: tags,
          checkoutUrl: checkoutUrl,

          createdAt: Date.now(),
        });
        setLoading(false);
        alert("Produto criado com sucesso!");
        setNome("");
        setImage(null);
        setVideo(null);
        setFichaTecnica("");
        setValor("");
        setAnunciante(null);
        setCategorias([]);
        setTags([]);
        setCheckoutUrl("");
        setDescricao("");
      } else {
        alert("O arquivo deve ser uma imagem. O vídeo deve ser formato MP4.");
      }
    } else {
      alert("Preencha todos os campos.");
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleVideoChange = (e) => {
    setVideo(e.target.files[0]);
  };

  const handleNomeChange = (e) => {
    setNome(e.target.value);
  };

  const handleDescChange = (e) => {
    setDescricao(e.target.value);
  };

  const handleFichaTecnicaChange = (e) => {
    setFichaTecnica(e.target.value);
  };

  const handleValorChange = (e) => {
    setValor(e.target.value);
  };

  const handleAnuncianteChange = (event, newValue) => {
    setAnunciante(newValue);
  };

  const handleCategoriasChange = (event, newValue) => {
    setCategorias(newValue);
  };

  const handleTagsChange = (event, newValue) => {
    setTags(newValue);
  };

  const handleCheckoutUrlChange = (e) => {
    setCheckoutUrl(e.target.value);
  };

  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={3}
        style={{ padding: "15px", textAlign: "center" }}
      >
        <Grid item xs={12} style={{ marginBottom: "15px" }}>
          <img src={icon} height="100px" />
          <Typography variant="h3">Criar Produto</Typography>
          <Divider />
        </Grid>

        <Grid item xs={10} style={{ textAlign: "center" }}>
          <form onSubmit={submit}>
            <Paper elevation={3} style={{ paddingTop: "15px" }}>
              <img
                src={image ? URL.createObjectURL(image) : placeholder}
                height="200px"
                width="200px"
                style={{ borderRadius: "1000px" }}
              />
              <br />
              <TextField type="file" onChange={handleImageChange} />
              <Divider style={{ margin: "15px" }} />
              {video ? (
                <video width="400" height="200" controls>
                  <source src={URL.createObjectURL(video)} type="video/mp4" />
                  Your browser does not support HTML video.
                </video>
              ) : (
                <img
                  src={placeholderVideo}
                  height="150px"
                  width="200px"
                  style={{ borderRadius: "10px" }}
                />
              )}

              <br />
              <TextField
                type="file"
                onChange={handleVideoChange}
                color="secondary"
              />
              <Divider style={{ margin: "15px" }} />

              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Nome do Produto"
                    autoFocus
                    type="text"
                    onChange={handleNomeChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Descrição"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={6}
                    color="secondary"
                    onChange={handleDescChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Ficha Técnica"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={6}
                    onChange={handleFichaTecnicaChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Valor ( R$ )"
                    type="number"
                    onChange={handleValorChange}
                    color="secondary"
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <FormControl fullWidth>
                    <Autocomplete
                      onChange={handleAnuncianteChange}
                      value={anunciante}
                      options={[
                        { nome: "oi", id: 2312313 },
                        { nome: "Tchau", id: 1221312 },
                      ]}
                      getOptionLabel={(option) => option.nome}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Anunciante"
                          variant="outlined"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <FormControl fullWidth>
                    <Autocomplete
                      onChange={handleCategoriasChange}
                      options={[
                        { nome: "oi", id: 2312313 },
                        { nome: "Tchau", id: 1221312 },
                      ]}
                      multiple
                      getOptionLabel={(option) => option.nome}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Categorias"
                          variant="outlined"
                          color="secondary"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <FormControl fullWidth>
                    <Autocomplete
                      onChange={handleTagsChange}
                      options={[
                        { nome: "oi", id: 2312313 },
                        { nome: "Tchau", id: 1221312 },
                      ]}
                      multiple
                      getOptionLabel={(option) => option.nome}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Tags"
                          variant="outlined"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="URL de Checkout"
                    type="text"
                    onChange={handleCheckoutUrlChange}
                    color="secondary"
                    value={checkoutUrl}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                  >
                    {!loading ? "Enviar" : <CircularProgress color="primary" />}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </form>
        </Grid>
      </Grid>
    </div>
  );
}
